export default __webpack_public_path__ + "static/media/slot2.3a0450c9.png";